(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('VpPaymentController', VpPaymentController);

    VpPaymentController.$inject = ['$state', 'DataUtils', 'VpPayment', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'ProfileIdByPhone', 'VpPaymentTotalAmount'];

    function VpPaymentController($state, DataUtils, VpPayment, ParseLinks, AlertService, paginationConstants, pagingParams, ProfileIdByPhone, VpPaymentTotalAmount) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.clear = clear;
        vm.search = search;
        vm.openProfile = openProfile;
        vm.currentSearch = pagingParams.search;
        vm.searchQuery = {
            field: pagingParams.field,
            client: pagingParams.client,
            amount: pagingParams.amount,
            valueString1: pagingParams.valueString1,
            valueLong1: pagingParams.valueLong1,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate
        };
        vm.operators = [
            {mts:"MTS"},
            {"beelinehphone":"Beeline"},
            {"yota_phone":"Yota Phone"},
            {"tele2":"Tele2"},
            {"megafon":"Megafon"},
            {"other":"Other"}
        ];

        initDatePicker();
        loadAll();
        getTotalAmount();

        function loadAll () {
            VpPayment.query({
                field: pagingParams.field,
                client: pagingParams.client,
                amount: pagingParams.amount,
                valueString1: pagingParams.valueString1,
                valueLong1: pagingParams.valueLong1,
                fromDate: pagingParams.fromDate,
                toDate: pagingParams.toDate,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.vpPayments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function initDatePicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.fromDate);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.toDate);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                $state.go('profile-detail', {id: data.profileId});
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                field: vm.searchQuery.field,
                client: vm.searchQuery.client,
                amount: vm.searchQuery.amount,
                valueString1: vm.searchQuery.valueString1,
                valueLong1: vm.searchQuery.valueLong1,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate
            });
        }

        function search(searchQuery) {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = {
                field: null,
                client: null,
                amount: null,
                valueString1: null,
                valueLong1: null,
                fromDate: null,
                toDate: null
            };
            vm.transition();
        }

        function getTotalAmount() {
            VpPaymentTotalAmount.get({
                field: pagingParams.field,
                client: pagingParams.client,
                amount: pagingParams.amount,
                valueString1: pagingParams.valueString1,
                valueLong1: pagingParams.valueLong1,
                fromDate: pagingParams.fromDate,
                toDate: pagingParams.toDate
            }, function (data) {
                vm.totalAmount = data.totalAmount;
            })
        }
    }
})();
